import React from 'react';
import CalendarEventItem from './CalendarEventItem';
import { useTranslations } from 'next-intl';
import { CalendarEvent } from '@wwe-portal/entities/calendar.type';

interface CalendarEventContainerProps {
  eventsDay: string;
  type: string;
  events: CalendarEvent[] | undefined;
}

function CalendarEventContainer({
  eventsDay,
  events,
  type,
}: Readonly<CalendarEventContainerProps>) {
  const t = useTranslations();

  if (!events || events.length === 0) return null;
  return (
    <div
      id={eventsDay}
      className="calendar__events__event-container flex w-full flex-col gap-1"
    >
      <p className="text-text500 mb-4 text-sm capitalize">
        {t(type)} {t('events')}
      </p>
      {events.map((event) => (
        <CalendarEventItem event={event} key={event.id} />
      ))}
    </div>
  );
}

export default CalendarEventContainer;
